module.exports = __webpack_public_path__ + "static/media/cnft.3469e304.png";